import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
export default class SaveDesignToProfileCardStyle {
    static getStyle(options) {
        const { spacing } = options.theme;
        return css `
			${Text.CSS}

			h2 {
				margin: 0;
				margin-bottom: ${spacing.space150 / 16}rem;
			}

			.productName {
				margin-top: ${spacing.space125 / 16}rem;
				margin-bottom: 0;
			}

			.productDescription {
				margin: 0;
			}

			/* CSS rules for visual reordering to maintain design while enhancing accessibility, compensating for HTML structure. */
			.designWrapper {
				display: flex;
				flex-direction: column;
			}

			.designWrapper img {
				order: -1;
			}
		`;
    }
}
//# sourceMappingURL=SaveDesignToProfileCardStyle.js.map